import { ReactNode } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
// import * as TabsLayout from '@/components/blocks/tabs-layout';
{
  /*
<TabsLayout.Root>
  <TabsLayout.Top>
    <TabsLayout.Label></TabsLayout.Label>
    <TabsLayout.Menu>
      <TabsLayout.MenuList>
        <TabsLayout.MenuButton></TabsLayout.MenuButton>
        <TabsLayout.MenuButton></TabsLayout.MenuButton>
        <TabsLayout.MenuButton></TabsLayout.MenuButton>
      </TabsLayout.MenuList>      
    </TabsLayout.Menu>
  </TabsLayout.Top>
  <TabsLayout.Bottom>
    <TabsLayout.Page></TabsLayout.Page>
    <TabsLayout.Page></TabsLayout.Page>
    <TabsLayout.Page></TabsLayout.Page>
  </TabsLayout.Bottom>
</TabsLayout.Root>
*/
}

export const Label = ({ children }: { children: ReactNode }) => {
  return <div className="flex">{children}</div>;
};

export const MenuButton = ({
  value,
  className,
  children,
}: {
  value: string;
  className?: string;
  children: ReactNode;
}) => {
  return (
    <TabsTrigger className={className} value={value}>
      {children}
    </TabsTrigger>
  );
};

export const MenuList = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return <TabsList className={cn("flex", className)}>{children}</TabsList>;
};

export const Menu = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return <div className={cn("flex", className)}>{children}</div>;
};

export const Top = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return (
    <div
      className={cn(
        "flex justify-between items-center p-1 border-b",
        className,
      )}
    >
      {children}
    </div>
  );
};

export const Page = ({
  value,
  children,
}: {
  value: string;
  children: ReactNode;
}) => {
  return (
    <TabsContent className="w-full h-full overflow-hidden" value={value}>
      {children}
    </TabsContent>
  );
};

export const Bottom = ({ children }: { children: ReactNode }) => {
  return <div className="flex flex-1 overflow-hidden">{children}</div>;
};

export const Root = ({
  value,
  onValueChange,
  children,
}: {
  value: any;
  onValueChange: (value: any) => void;
  children: ReactNode;
}) => {
  return (
    <Tabs
      // defaultValue={currentTab}
      value={value}
      onValueChange={onValueChange}
      className="w-full h-full"
    >
      <div className="flex flex-col h-full">{children}</div>
    </Tabs>
  );
};
